/**
 * @generated SignedSource<<b0850a2bed09307611013a765a6e7f79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type JwtDeviceKindKind = "Admin" | "App" | "WebApp";
export type LoginAsUserJwtInput = {
  clientMutationId?: string | null;
  deviceKind: JwtDeviceKindKind;
  userId: string;
};
export type impersonateUserButton_loginAsUserJwtMutation$variables = {
  input: LoginAsUserJwtInput;
};
export type impersonateUserButton_loginAsUserJwtMutation$data = {
  readonly Admin: {
    readonly Auth: {
      readonly loginAsUserJwt: {
        readonly jwtTokens: {
          readonly accessToken: string;
          readonly refreshToken: string;
        };
      } | null;
    };
  };
};
export type impersonateUserButton_loginAsUserJwtMutation = {
  response: impersonateUserButton_loginAsUserJwtMutation$data;
  variables: impersonateUserButton_loginAsUserJwtMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Auth",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "LoginAsUserJwtPayload",
            "kind": "LinkedField",
            "name": "loginAsUserJwt",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "JwtLoginInformation",
                "kind": "LinkedField",
                "name": "jwtTokens",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessToken",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refreshToken",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "impersonateUserButton_loginAsUserJwtMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "impersonateUserButton_loginAsUserJwtMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4e6c8ba92789e44a9cf5ec1e3bc35cd2",
    "id": null,
    "metadata": {},
    "name": "impersonateUserButton_loginAsUserJwtMutation",
    "operationKind": "mutation",
    "text": "mutation impersonateUserButton_loginAsUserJwtMutation(\n  $input: LoginAsUserJwtInput!\n) {\n  Admin {\n    Auth {\n      loginAsUserJwt(input: $input) {\n        jwtTokens {\n          accessToken\n          refreshToken\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d725289b66f7ff5843e77ec097dbf824";

export default node;
